import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import {
  FirstAvailable,
  NoAvailability,
  PhysicianSlotPicker,
} from './PhysicianSlotsPickerGroupsByDay'
import {
  AvailablePhysicianSlot,
  AvailableSlotsByProviderResponse,
  toWireReason,
  VisitReason,
} from '../AppointmentService'

type PhysicianSlotDetailsProps = {
  physicianSlots: AvailableSlotsByProviderResponse
  physicianId: number
  reason: VisitReason | null
  slot: AvailablePhysicianSlot | null
  setSlot: (value: AvailablePhysicianSlot) => void
  setDate: (value: Date) => void
  bookingWindowInHours?: number
}
const PhysicianSlotDetails: FC<PhysicianSlotDetailsProps> = ({
  physicianSlots,
  physicianId,
  reason,
  slot,
  setSlot,
  setDate,
  bookingWindowInHours,
}) => {
  return (
    <>
      {physicianSlots.slots.length && reason ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginBottom: 2,
            marginTop: 1,
            flexWrap: 'wrap',
            rowGap: 1,
          }}
        >
          <PhysicianSlotPicker
            slots={physicianSlots.slots}
            physicianId={physicianId}
            reason={toWireReason(reason)}
            inCareTeam={
              false
            } /* By-provider view doesn't compute care-team; false is a neutral default and only affects UI grouping, not booking/API */
            value={slot}
            onChange={setSlot}
          />
        </Box>
      ) : physicianSlots.first_available_slot ? (
        <FirstAvailable
          firstAvailableSlot={physicianSlots.first_available_slot}
          setDate={setDate}
        />
      ) : (
        <NoAvailability bookingWindowInHours={bookingWindowInHours} />
      )}
      {physicianSlots.reasons_for_unavailability.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginBottom: 2,
            marginTop: 4,
            flexWrap: 'wrap',
            rowGap: 1,
          }}
        >
          <Typography variant="body2">
            If you are not seeing available slots as expected, it may be due to:
            <ul>
              {physicianSlots.reasons_for_unavailability.map((reason: string) => (
                <li key={reason}>
                  <Typography variant="body2">{reason}</Typography>
                </li>
              ))}
            </ul>
          </Typography>
        </Box>
      )}
    </>
  )
}

export default PhysicianSlotDetails
